import { ApiCore } from '@/services/api/utils/core.js'
import { apiProvider } from '@/services/api/utils/provider.js'
import axios from 'axios'
import { handleResponse, handleError } from '@/services/api/utils/response.js'

const url = 'v1/eclip'
const plural = 'eclips'
const single = 'eclip'
const folder = 'v1/eclips/folders'

const api = new ApiCore({
	index: true,
	create: true,
	url: url,
	plural: plural,
	single: single,
})

api.get = (id, options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}`, options)
		.then(handleResponse)
		.catch(handleError);
}

api.send = (id, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/send`, payload, options)
		.then(handleResponse)
}

api.requestMoreInfo = (id, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/request-more-information`, payload, options)
		.then(handleResponse)
}

api.setRefNumber = (id, payload, options) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}/reference-number`, payload, options)
		.then(handleResponse)
}

api.importMessageData = (eclipId, messageStoreId) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${eclipId}/data-element-import/${messageStoreId}`, {})
		.then(handleResponse)
}

api.addRemoveDataElements = (eclipId, payload) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${eclipId}/data-elements`, payload)
		.then(handleResponse)
		.catch(handleError);
}

api.update = (id, payload, options) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${id}`, payload, options)
		.then(handleResponse)
		.catch(handleError);
}

api.findAll = (params) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}`, { params })
		.then(handleResponse)
		.catch(handleError);
}

api.activityLog = (id) => {
	return axios
		.get(`${apiProvider.BASE_URL}/${url}/${id}/activity-log`,)
		.then(handleResponse)
		.catch(handleError);
}

api.pinEclip = (action, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/eclips/pin-to-top/${action}`,payload, options)
		.then(handleResponse)
		.catch(handleError);
}

api.createActivityLog = (id, payload, options) => {
	return axios
		.post(`${apiProvider.BASE_URL}/${url}/${id}/activity-log`,payload, options)
		.then(handleResponse)
		.catch(handleError);
}

api.getDataElements = (options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/eclips/data-elements`, options)
		.then(handleResponse)
		.catch(handleError);
}

api.getReceivedEclips = (dataElementId, options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/eclips/received/${dataElementId}`, options)
		.then(handleResponse)
		.catch(handleError);
}

api.getReceivedMessages = (dataElementId, options) => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/data-element/${dataElementId}/received-messages`, options)
		.then(handleResponse)
		.catch(handleError);
}

api.packageOwnerUpdate = (eclipId, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${eclipId}/owner`, payload)
		.then(handleResponse)
		.catch(handleError);
}

api.clearImportData = (eclipId, dataElementId) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/${url}/${eclipId}/imported/${dataElementId}`)
		.then(handleResponse)
		.catch(handleError);
}


api.respondRequest = (eclipId, action, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${eclipId}/request/${action}`, payload)
		.then(handleResponse)
		.catch(handleError);
}

api.declineRequest = (eclipId, payload) => {
	return axios
		.put(`${apiProvider.BASE_URL}/${url}/${eclipId}/decline`, payload)
		.then(handleResponse)
		.catch(handleError);
}


api.getUsers = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/users`);
}

api.getTags = () => {
	return axios
		.get(`${apiProvider.BASE_URL}/v1/tags`);
}

api.deleteTag = (id) => {
	return axios
		.delete(`${apiProvider.BASE_URL}/v1/tags/${id}`)
		.then(handleResponse)
		.catch(handleError);
}

api.createTags = (id, tags) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/eclip/${id}/tags`, { tags })
		.then(handleResponse)
		.catch(handleError);
}

api.updateIsNew = (eclipId, dataElementId) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/eclips/${eclipId}/${dataElementId}/updateIsNew`)
		.then(handleResponse)
		.catch(handleError);
}

api.cancelUpdateEclip = (eclipId) => {
	return axios
		.post(`${apiProvider.BASE_URL}/v1/eclips/${eclipId}/cancel`)
		.then(handleResponse)
		.catch(handleError);
}

export default api
